/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

/**
 * Key-value tags for additional metadata
 */
export type UpdateSpaceDtoTags = { [key: string]: string };
